import { SuccesspageComponent } from './teacher/components/successpage/successpage.component';
import { AccountSettingsComponent } from './teacher/account-settings/account-settings.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SimpleGuard } from '@delon/auth';
import { environment } from '@env/environment';
import { LayoutDefaultComponent } from '../layout/default/default.component';
import { LayoutPassportComponent } from '../layout/passport/passport.component';
import { TeacherComponent } from './teacher/teacher.component';
import { UserLoginComponent } from './passport/login/login.component';
import { DownloadComponent } from '../layout/passport/download/download.component';

const routes: Routes = [
    {
        path: '',
        component: LayoutDefaultComponent,
        canActivate: [SimpleGuard],
        children: [
            { path: '', redirectTo: 'teacher', pathMatch: 'full' },
            { path: 'teacher', component: TeacherComponent, data: { title: '首页', reuse: true, reuseClosable: false } },
            { path: 'account-settings', component: AccountSettingsComponent, data: { title: '个人设置', reuse: true } },
            {
                path: 'grxx',
                loadChildren: () => import('./teacher/notification/notification.module').then(mod => mod.NotificationModule),
            },
            {
                path: 'grxx',
                loadChildren: () => import('./teacher/task/task.module').then(mod => mod.TaskModule),
            },
            { path: 'pyfa', loadChildren: () => import('./teacher/pyfa/pyfa.module').then(mod => mod.PyfaModule) },
            { path: 'jxap', loadChildren: () => import('./teacher/jxap/jxap.module').then(mod => mod.JxapModule) },
            { path: 'jxyx', loadChildren: () => import('./teacher/jxyx/jxyx.module').then(mod => mod.JxyxModule) },
            { path: 'jcgl', loadChildren: () => import('./teacher/jcgl/jcgl.module').then(mod => mod.JcglModule) },
            { path: 'kw', loadChildren: () => import('./teacher/kwgl/kwgl.module').then(mod => mod.KwglModule) },
            { path: 'cjgl', loadChildren: () => import('./teacher/cjgl/cjgl.module').then(mod => mod.CjglModule) },
            { path: 'pjgl', loadChildren: () => import('./teacher/pjgl/pjgl.module').then(mod => mod.PjglModule) },
            { path: 'bygl', loadChildren: () => import('./teacher/bygl/bygl.module').then(mod => mod.ByglModule) },
            { path: 'jczy', loadChildren: () => import('./teacher/jczy/jczy.module').then(mod => mod.JczyModule) },
            { path: 'xtwh', loadChildren: () => import('./teacher/xtwh/xtwh.module').then(mod => mod.XtwhModule) },
            { path: 'gdgl', loadChildren: () => import('./teacher/gdgl/gdgl.module').then(mod => mod.GdglModule) },
            { path: 'student', loadChildren: () => import('./student/student.module').then(mod => mod.StudentModule) },
            { path: 'successpage/:data', component: SuccesspageComponent, data: { title: '操作成功', reuse: false } },
        ],
    },
    {
        path: 'passport',
        component: LayoutPassportComponent,
        children: [{ path: 'login', component: UserLoginComponent, data: { title: '登录' } }],
    },
    { path: 'download', component: DownloadComponent, data: { title: 'APP下载' } },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            useHash: environment.useHash,
            // NOTICE: If you use `reuse-tab` component and turn on keepingScroll you can set to `disabled`
            // Pls refer to https://ng-alain.com/components/reuse-tab
            scrollPositionRestoration: 'top',
        }),
    ],
    exports: [RouterModule],
})
export class RouteRoutingModule { }
